// extracted by mini-css-extract-plugin
export default {"container":"ProfileHeader_container__d+-IB","profileDetails":"ProfileHeader_profileDetails__etiGK","name":"ProfileHeader_name__w9d7S","userName":"ProfileHeader_userName__RBAVS"};